<div fxLayout="row" fxFlex>
  <div
    class="sort-row"
    fxLayout="row"
    fxLayoutAlign="end center"
    *ngIf="customViewDisplayLayout == customViewDisplayLayoutEnum.List"
  >
    <div fxFlexAlign="end" class="sort-by-label">Sort by:</div>
    <a [matMenuTriggerFor]="menu" [attr.title]="'Sort Talent'" class="sort-options"
      >{{ currentSortOption?.label }}
      <mat-icon>arrow_drop_down</mat-icon>
      <mat-menu #menu="matMenu" yPosition="below" [overlapTrigger]="false">
        <button *ngFor="let sort of sortOptions" mat-menu-item (click)="changeSort(sort)">
          <span>{{ sort.label }}</span>
        </button>
      </mat-menu>
    </a>
  </div>
  <mat-paginator
    *ngIf="resultCount !== undefined"
    [length]="resultCount"
    [hidePageSize]="true"
    (page)="pageChanged($event)"
    aria-label="Change page"
  >
  </mat-paginator>
</div>
